import React from 'react';

import {clientOriginToDisplayName, getEnabledClientOrigins} from 'processes/ProcessConstants';
import {SingleValueFilter} from 'search/SearchConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';
import pickDefined from 'util/pickDefined';

import DropdownFilterForm, {prefixedToggleText} from './base/DropdownFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export interface ProcessClientOriginFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onRemove?: () => void;
}

export default function ProcessClientOriginFilterForm(
  props: ProcessClientOriginFilterFormProps
): JSX.Element {
  const optionDatas: Array<OptionData> = getEnabledClientOrigins().map((clientOrigin) => ({
    name: clientOriginToDisplayName[clientOrigin],
    value: clientOrigin,
    dataTestAttrs: {
      component: 'ProcessClientOriginFilterForm',
      element: 'option',
      key: clientOrigin,
    },
  }));
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <DropdownFilterForm
      {...skeletonProps}
      dropdownToggleText={prefixedToggleText('View', optionDatas, props.filter)}
      optionDatas={optionDatas}
      filterStyle={props.filterStyle}
      isMulti={false}
      isSearchable={false}
      onRemove={props.onRemove}
      value={props.filter.value}
      onChangeValue={(value: string) => {
        props.onChangeFilter({...props.filter, value});
      }}
      dataTestAttrs={{
        component: 'ProcessClientOriginFilterForm',
        element: 'root',
      }}
    />
  );
}
